module.exports = __webpack_public_path__ + "static/img/ai_content1.1477ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/matrix/ai_content1.png
// module id = 2ef9
// module chunks = 34